<div class="regular-size-selector" *ngIf="checkfitment && hasPricing()">
  <div class="wheel-selection">
    
    <!-- Wheel Size Selection -->
    <div class="selection-section">
      <h5 class="selection-title">Select Wheel Size</h5>
      
      <div class="size-selection-row">
        <div class="size-selector">
          <select 
            [(ngModel)]="selectedWheelSize" 
            (change)="onSizeSelect($event)"
            class="form-control search-inputs search-inputs-bold">
            <option value="">Choose Wheel Size</option>
            <option *ngFor="let wheel of availableWheels" [value]="wheel.id">
              {{ formatWheelOption(wheel) }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Quantity Selection (only show if wheel is selected) -->
    <div class="quantity-section" *ngIf="selectedWheelSize">
      <h5 class="selection-title">Select Quantity</h5>
      
      <div class="quantity-selection-row">
        <!-- Quick quantity buttons -->
        <div class="quantity-quick-select">
          <button 
            *ngFor="let qty of getQuantityOptions()" 
            type="button"
            class="btn qty-option-btn"
            [class.btn-primary]="quantity === qty"
            [class.btn-outline-primary]="quantity !== qty"
            [class.recommended]="isStandardSet(qty)"
            (click)="quantity = qty; updatePricing(); updateCartItems()">
            {{ qty }}
            <small *ngIf="isStandardSet(qty)" class="qty-label">(Set)</small>
          </button>
        </div>
        
        <!-- Custom quantity controls -->
        <div class="quantity-controls">
          <label class="quantity-label">Custom Quantity:</label>
          <div class="qty-input-group">
            <button 
              type="button"
              class="btn btn-outline-secondary btn-sm qty-btn"
              (click)="adjustQuantity(-1)"
              [disabled]="quantity <= 1">
              -
            </button>
            <input 
              [(ngModel)]="quantity" 
              (ngModelChange)="updatePricing(); updateCartItems()"
              type="number" 
              class="form-control qty-input"
              min="1" 
              max="8">
            <button 
              type="button"
              class="btn btn-outline-secondary btn-sm qty-btn"
              (click)="adjustQuantity(1)"
              [disabled]="quantity >= 8">
              +
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing Display (only show if wheel and quantity selected) -->
    <div class="pricing-section" *ngIf="selectedWheelSize && quantity > 0">
      <div class="pricing-display">
        <div class="price-breakdown">
          <div class="unit-price">
            <span class="price-label">Price per wheel:</span>
            <span class="price-value">
              ${{ getUnitPrice() | number:'1.2-2' }}
              <small *ngIf="showSalePrice" class="sale-indicator">(Sale Price)</small>
            </span>
          </div>
          
          <div class="total-price">
            <span class="price-label">Total ({{ quantity }} wheels):</span>
            <span class="price-value total">
              ${{ getEffectivePrice() | number:'1.2-2' }}
            </span>
          </div>
          
          <!-- Original price if on sale -->
          <div class="original-price" *ngIf="showSalePrice">
            <span class="price-label">Regular price:</span>
            <span class="price-value strikethrough">
              ${{ (unitPrice * quantity) | number:'1.2-2' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>

<!-- No fitment or pricing message -->
<div *ngIf="!checkfitment || !hasPricing()" class="no-selection-message">
  <p class="text-muted">
    <span *ngIf="!checkfitment">Please check fitment to select wheel sizes.</span>
    <span *ngIf="checkfitment && !hasPricing()">Pricing information not available.</span>
  </p>
</div>
